import cn from 'classnames';
// UI2
import Icon, { IconNames } from 'ui/Icon/Icon';
// Styles
import styles from './Banner.module.scss';

type BannerProps = {
  type?: 'default' | 'info' | 'success' | 'warning' | 'error';
  open: boolean;
  onClose?: () => void;
  message: string | JSX.Element;
  className?: string;
};

const getIconName = (type: BannerProps['type']): IconNames => {
  switch (type) {
    case 'info': {
      return 'dialogue';
    }
    case 'success': {
      return 'checkmark';
    }
    case 'warning': {
      return 'attention';
    }
    case 'default': {
      return 'attention';
    }
    case 'error': {
      return 'close-new';
    }
    default: {
      return 'info';
    }
  }
};

const Banner = ({
  type = 'default',
  open,
  onClose,
  message,
  className,
}: BannerProps) => {
  const iconName = getIconName(type);

  if (!open) {
    return null;
  }

  return (
    <div
      className={cn(
        styles.root,
        {
          [styles[`type-${type}`]]: type,
        },
        className
      )}
    >
      <div className={styles.entry}>
        <div className={styles.iconWrapper}>
          <Icon name={iconName} className={styles.icon} />
        </div>

        <p className={styles.message}>{message}</p>

        {onClose && (
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label={`Hide ${type} banner`}
          >
            <Icon name="close-new" className={styles.closeIcon} />
          </button>
        )}
      </div>
    </div>
  );
};

Banner.displayName = 'Banner';

export default Banner;
